import { createApp } from "vue";
import "./style.css";
import App from "./App.vue";
import router from "./router";
import DataVVue3 from "@kjgl77/datav-vue3";
import { createPinia } from "pinia";
import "element-plus/dist/index.css";
import 'element-plus/theme-chalk/dark/css-vars.css'

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { initRem, destroyRem } from '@/utils/rem'
import { logger } from '@/utils/errorLogger'

initRem()

const app = createApp(App);

// 🔧 添加全局错误处理器 - 防止未捕获异常导致应用崩溃
app.config.errorHandler = (err, instance, info) => {
  logger.error('Vue组件错误', err as Error, { info, componentName: instance?.$options?.name });
};

// 🔧 添加全局 Promise rejection 处理器
window.addEventListener('unhandledrejection', (event) => {
  logger.error('未处理的Promise rejection', event.reason);
  event.preventDefault(); // 防止默认行为（在控制台显示错误）
});

// 🔧 添加全局 JavaScript 错误处理器
window.addEventListener('error', (event) => {
  logger.error('JavaScript运行时错误', event.error, {
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno
  });
});

// 应用级别清理 - 防止内存泄漏
window.addEventListener('beforeunload', () => {
  destroyRem()
  // 清理可能存在的全局状态

  // 导出错误日志（可选）
  // const logs = logger.exportLogs();
  // console.log('[应用卸载] 错误日志:', logs);
})

// 🔧 应用保活监控 - 检测应用是否正常运行
let lastActiveTime = Date.now()
let heartbeatTimer: any = null

// 更新活动时间
const updateActiveTime = () => {
  lastActiveTime = Date.now()
}

// 监听用户活动
window.addEventListener('mousemove', updateActiveTime, { passive: true })
window.addEventListener('keydown', updateActiveTime, { passive: true })
window.addEventListener('click', updateActiveTime, { passive: true })

// 心跳检测 - 每5分钟检查一次应用是否正常
const startHeartbeat = () => {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer)
  }

  heartbeatTimer = setInterval(() => {
    const now = Date.now()
    const inactiveTime = now - lastActiveTime

    // 如果超过1小时没有活动，可能是应用卡死
    if (inactiveTime > 60 * 60 * 1000) {
      console.warn('[应用保活] ⚠️ 应用可能卡死，尝试恢复...')
      // 可以在这里添加恢复逻辑，比如刷新页面
      // window.location.reload()
    }

    // 输出心跳日志
    console.log(`[应用保活] ❤️ 应用运行正常，距上次活动: ${Math.floor(inactiveTime / 1000)}秒`)
  }, 5 * 60 * 1000) // 每5分钟检查一次
}

// 启动心跳检测
startHeartbeat()

app.use(DataVVue3);
app.use(router);
app.use(createPinia());
app.mount("#app");
